import { toApiUrl } from '../utils/apiBase';
import { receivingBankOptions, manualReceiverPayload } from '../utils/receivingBanks';
import React, { useState, useContext, useEffect } from 'react';
import { Button as Button2 } from '../shadcn/Button';
import firestore from '../firestore';
import Firebase from '../firebase_setup';
import { GlobalContext } from '../context/GlobalContext';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';
import { ContainerSpinner } from '../components/Spinner';
import Pay from './pay';
import useFetch, { callAPI, unsafeAPI } from '../hooks/api';
import { API_BASE } from '../utils/constants';
import { Dialog } from '../components/Dialog';
import Input from '../components/Input';
import Select from '../components/Select';
import { validate_bank_account_number, validate_phone_number } from '../utils/validate';
import Notice from '../components/Notice';
import Table from '../components/Table';
import { SearchIcon } from 'lucide-react';
import { DatePicker } from '../shadcn/DatePicker';
import Promociones from './promociones';
import FinancingOptionsConfig from './admin/financing-configuration';
import PromotionsConfiguration from './admin/promotions-configuration';
import ManageCustomers from './admin/manage-customers';
import AccessControl from './admin/access-control';
import NewSale from './nuevo-registro';
import ManageStores from './admin/manage-stores';
import LogInAs from './log-in-as';
import PagosAliados from './admin/pagos-a-aliados';
import RegisterPaymentManually from './admin/registrar-pago-manual';
import PushNotifications from './admin/push-notifications';
import LifecycleNotifications from './admin/lifecycle-notifications';
import LoansBatchDelete from './admin/eliminacion-de-prestamos';
import MarketingCampaigns from './admin/marketing-campaigns';
import StoreAnnouncementsAdmin from './admin/store-announcements';
import StorePopups from './admin/store-banner';
import MdmRouting from './admin/mdm-routing';
import BankAccountMappings from './admin/bank-account-mappings';
import Conciliaciones from './admin/conciliaciones';
import ReleaseImei from './admin/release-imei';
import SellerCommissionsAdmin from './admin/comisiones-vendedores';
import InsurancePolicies from './admin/insurance-policies';
import StoreRequests from './admin/store-requests';

const Internal = () => {
	const { userData, internalPath, internalCountry, CountrySettings } = useContext(GlobalContext);
	const selectedCountry = internalCountry.get() || userData?.country;

	const [isLoading, setIsLoading] = useState(false);
	const [storeCommercialName, setStoreCommercialName] = useState('');
	const [storeEmail, setStoreEmail] = useState('');

	const [paymentDate, setPaymentDate] = useState('');
	const [reportedAmount, setReportedAmount] = useState('');
	const [masterEmail, setMasterEmail] = useState('');
	const [isEntel, setIsEntel] = useState(false);
	const [file, setFile] = useState(null);
	const [dialogMessage, setDialogMessage] = useState('');

	const showDialogMessage = (message) => {
		setDialogMessage(message);
	};

	const handleFileChange = (event) => {
		const selectedFile = event.target.files[0];
		if (selectedFile) {
			setFile(selectedFile);
		}
	};

	const uploadFile = async (event) => {
		try {
			const file = event.target.files[0];
			if (!file) throw new Error('No file provided');

			const storage = Firebase.storage();
			const storageRef = storage.ref();
			const extension = file.name.split('.').pop();
			const fileName = `csv_url.${extension}`;
			const fileRef = storageRef.child(fileName);

			await fileRef.put(file);
			const downloadURL = await fileRef.getDownloadURL();

			// Send downloadURL to updatebalances endpoint
			const response = await sendPostRequest2({ csv_url: downloadURL }, 'payments/updatebalances/');

			if (!response?.success) {
				throw new Error(response?.status || 'Failed to update balances');
			} else {
				showDialogMessage('Balances actualizados exitosamente');
			}

			return downloadURL;
		} catch (error) {
			console.error('Error uploading file:', error);
			throw error;
		}
	};

	const uploadFile2 = async (event) => {
		try {
			const file = event.target.files[0];
			if (!file) throw new Error('No file provided');

			const storage = Firebase.storage();
			const storageRef = storage.ref();
			const extension = file.name.split('.').pop();
			const fileName = `csv_url.${extension}`;
			const fileRef = storageRef.child(fileName);

			await fileRef.put(file);
			const downloadURL = await fileRef.getDownloadURL();

			// Send downloadURL to updatebalances endpoint
			const response = await sendPostRequest2({ csv_url: downloadURL }, 'payments/uploadrdbanktransactions/');

			if (!response?.success) {
				throw new Error(response?.status || 'Failed to update balances');
			} else {
				showDialogMessage('Balances actualizados exitosamente');
			}

			return downloadURL;
		} catch (error) {
			console.error('Error uploading file:', error);
			throw error;
		}
	};

	const parseCSV = (csvString) => {
		const results = {};
		Papa.parse(csvString, {
			header: true,
			complete: (data) => {
				data.data.forEach((row) => {
					results[row['Nombre de Aliado']] = row['ID'];
				});
			}
		});
		return results;
	};

	const formatHoursOfOperation = (hours) => {
		if (!hours || typeof hours !== 'object') return '';

		const days = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'];
		const formattedHours = days
			.filter((day) => hours[day]?.active)
			.map((day) => {
				const { from, to } = hours[day];
				return `${day}: ${from}:00-${to}:00`;
			})
			.join(', ');

		return formattedHours || '';
	};

	const exportTiendasCSV = async () => {
		if (!file) {
			showDialogMessage('Subir un archivo CSV primero.');
			return;
		}

		try {
			const csvString = await file.text();
			const aliados = parseCSV(csvString);

			const storesSnapshot = await firestore
				.collection('Stores')
				.where('country', '==', userData.country)
				.where('is_active', '==', true)
				.get();

			// Array to store CSV data
			const csvData = [];

			// Iterate through each document
			storesSnapshot.forEach((doc) => {
				const storesInfo = doc.data().stores_info || {};

				// Iterate through each store name in stores_info
				Object.entries(storesInfo).forEach(([store_name, storeData]) => {
					if (!aliados[store_name]) {
						console.log('Store: ' + store_name);
					}

					// Check if sucursales array exists and has items
					if (storeData.sucursales && Array.isArray(storeData.sucursales)) {
						storeData.sucursales.forEach((sucursal) => {
							const storeRow = {
								'Nombre de la tienda': sucursal.store_name || '',
								'Link de google maps': `https://www.google.com/maps/search/?api=1&query=${sucursal.location || ''}`,
								Horario: formatHoursOfOperation(sucursal.hours_of_operation),
								Aliado: aliados[store_name] || '',
								'Direccion corta': sucursal.location || '',
								Ciudad: JSON.stringify(Array.from([sucursal.city])) || '',
								'Ubicacion maps': JSON.stringify({ formatted: sucursal.location, city: sucursal.city })
							};

							csvData.push(storeRow);
						});
					}
				});
			});

			// Use PapaParse to convert JSON array to CSV string
			const csvStringOutput = Papa.unparse(csvData);

			// Create a Blob object for the CSV file
			const blob = new Blob([csvStringOutput], { type: 'text/csv;charset=utf-8;' });

			// Use FileSaver to save the CSV file
			saveAs(blob, 'Tiendas.csv');

			console.log('Tiendas.csv file created successfully!');
		} catch (error) {
			console.error('Error exporting Tiendas to CSV:', error);
		}
	};

	async function exportAliadosCSV() {
		try {
			const storesSnapshot = await firestore
				.collection('Stores')
				.where('country', '==', userData.country)
				.where('is_active', '==', true)
				.get();

			// Array to store CSV data
			const csvData = [];

			// Iterate through each document
			storesSnapshot.forEach((doc) => {
				const storesInfo = doc.data().stores_info || {};

				// Iterate through each store name in stores_info
				Object.entries(storesInfo).forEach(([store_name, storeData]) => {
					// Extract and format cities from sucursales array using a Set to ensure uniqueness
					const uniqueCities = new Set();
					if (storeData.sucursales && Array.isArray(storeData.sucursales)) {
						storeData.sucursales.forEach((sucursal) => {
							if (sucursal.city) {
								uniqueCities.add(sucursal.city);
							}
						});
					}

					// Convert the Set to an array and format as ["City1", "City2", "City3"]
					const formattedCities = JSON.stringify(Array.from(uniqueCities));

					// Create a row for each store with the desired fields
					const row = {
						'Nombre de Aliado': store_name || '',
						'Logo/Marca':
							storeData.info?.logo ||
							'https://firebasestorage.googleapis.com/v0/b/krece-fa736.appspot.com/o/logos_aliados%2Fkrece_logo_blue.png?alt=media&token=d19c73b2-80af-4cc0-aa1a-4d304a2ed017',
						'Whatsapp Link': storeData.info?.whatsapp_link || '',
						Instagram: storeData.info?.instagram_link || '',
						Ciudades: formattedCities
					};

					// Push the row into csvData array
					if (formattedCities !== '[]') {
						csvData.push(row);
					}
				});
			});

			// Use PapaParse to convert JSON array to CSV string
			const csvString = Papa.unparse(csvData);

			// Create a Blob object for the CSV file
			const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

			// Use FileSaver to save the CSV file with the name Aliados.csv
			saveAs(blob, 'Aliados.csv');

			console.log('CSV file created successfully!');
		} catch (error) {
			console.error('Error exporting Aliados to CSV:', error);
		}
	}

	const getStoreTransactions = async () => {
		try {
			if (!reportedAmount || !paymentDate || !storeEmail) {
				showDialogMessage('Por favor rellene todos los datos');
				return;
			}
			setIsLoading(true);
			const data = {
				store_email: storeEmail.trim(),
				amount: convertToDotDecimal(reportedAmount),
				date: formatForAPI(paymentDate)
			};
			const response = await sendPostRequest2(data, 'find_payment_based_on_price/');
			if (response?.success && Array.isArray(response.data)) {
				showDialogMessage(
					response.status +
						'. Se encontraron los siguientes números de referencia: ' +
						JSON.stringify(response.data.map((obj) => obj.reference))
				);
			} else if (response?.status) {
				showDialogMessage('Error: ' + response.status);
			} else {
				showDialogMessage('Ocurrio un problema intente mas tarde.');
			}
		} catch (err) {
			showDialogMessage('Error: ' + err.message);
		} finally {
			setIsLoading(false);
		}
	};

	async function exportCitiesCSV() {
		try {
			const storesSnapshot = await firestore.collection('Stores').where('country', '==', userData.country).get();
			const cities = new Set();

			storesSnapshot.forEach((doc) => {
				const storesInfo = doc.data().stores_info || {};

				// Iterate through each store name in stores_info
				Object.values(storesInfo).forEach((storeData) => {
					// Check if sucursales array exists and has items
					if (storeData.sucursales && Array.isArray(storeData.sucursales)) {
						// Add each unique city to the Set
						storeData.sucursales.forEach((sucursal) => {
							if (sucursal.city) {
								cities.add(sucursal.city);
							}
						});
					}
				});
			});

			// Convert Set to Array and continue with CSV creation
			const citiesArray = Array.from(cities);

			// Create a CSV formatted object
			const csvData = citiesArray.map((city) => ({ Title: city }));

			// Use PapaParse to convert JSON array to CSV string
			const csvString = Papa.unparse(csvData);

			// Create a Blob object for the CSV file
			const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

			// Use FileSaver to save the CSV file with the name Ciudades.csv
			saveAs(blob, 'Ciudades.csv');

			console.log('CSV file created successfully!');
		} catch (error) {
			console.error('Error exporting cities to CSV:', error);
		}
	}

	const sendPostRequest2 = async (data, endpoint) => {
		try {
			const idToken = await Firebase.auth().currentUser.getIdToken(true);
			const response = await fetch(toApiUrl(endpoint), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${idToken}`,
					'x-master-store-email': userData.email,
					'x-user-email': userData.email
				},
				body: JSON.stringify({ ...data, country: internalCountry.get() || userData.country, store_user: userData.email })
			});
			const responseData = await response.json();
			return responseData;
		} catch (error) {
			console.error('Error:', error.message);
			return null;
		}
	};

	function convertToDotDecimal(str) {
		if (/^[+-]?(\d{1,3}(,\d{3})*|\d+)(,\d+)?$/.test(str)) {
			return str.replace(/,/g, '.');
		} else {
			return str;
		}
	}

	function formatForAPI(date) {
		// Format the date as yyyy/mm/dd
		const formattedDate = date
			.toLocaleString('en-CA', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				timeZone: 'America/New_York' // GMT-4 timezone (Eastern Time)
			})
			.replace(/\//g, '-'); // Replace slashes with dashes

		return formattedDate;
	}

	const createMasterAccount = async () => {
		setIsLoading(true);
		if (!storeCommercialName || !masterEmail) {
			showDialogMessage('Por favor rellene todos los datos.');
			setIsLoading(false);
			return;
		}
		try {
			const data = {
				financed_by_krece: true,
				country: internalCountry.get() || userData.country,
				entel_parter: isEntel,
				store_name: storeCommercialName,
				master_store_email: masterEmail,
				store_user: userData.email
			};

			const response = await unsafeAPI('POST', `${API_BASE}/storeprofile/masteruser/`, data, userData, internalCountry.get());

			if (response?.success) {
				showDialogMessage('Cuenta creada con exito!');
			} else if (!response?.success) {
				showDialogMessage('Error: ' + response.status);
			} else {
				showDialogMessage('Ocurrio un problema intente mas tarde.');
			}
			setIsLoading(false);
		} catch (err) {
			showDialogMessage('Error: ' + err.message);
			setIsLoading(false);
		}
	};

	if (isLoading) {
		return <ContainerSpinner size={3} />;
	}

	function NoAccess() {
		return <></>;
	}

	const Onboarding = (
		<div className="mx-auto w-full max-w-5xl space-y-8 p-4 md:p-6">
			<div className="space-y-6 rounded-lg border border-neutral-800 bg-neutral-900/50 p-6">
				<div className="space-y-0">
					<h2 className="text-2xl font-semibold text-neutral-100">Crear cuenta master</h2>
					<p className="text-sm text-neutral-400">Complete los datos para crear una nueva cuenta maestra</p>
				</div>

				<div className="mx-auto max-w-xl space-y-4">
					<Input
						floatingLabel="Correo cuenta master"
						placeholder="correo@ejemplo.com"
						name="masterEmail"
						value={masterEmail}
						onChange={(value) => setMasterEmail(value)}
						containerClassName="w-full"
						type="email"
					/>
					<Input
						floatingLabel="Nombre del comercio"
						placeholder="Mi Comercio"
						name="storeCommercialName"
						value={storeCommercialName}
						onChange={(value) => setStoreCommercialName(value)}
						containerClassName="w-full"
					/>
					{userData.country === 'peru' && (
						<Select
							floatingLabel="Referido por Entel"
							options={[
								{ label: 'No', value: false },
								{ label: 'Si', value: true }
							]}
							defaultValue={isEntel}
							onSelectedChange={setIsEntel}
							placeholder="Seleccionar opción"
							containerClassName="w-full"
						/>
					)}
					<Button2 variant="primary" onClick={createMasterAccount} className="!h-12 w-full">
						Crear Cuenta
					</Button2>
				</div>
			</div>

			<div className="space-y-6 rounded-lg border border-neutral-800 bg-neutral-900/50 p-6">
				<div className="space-y-0">
					<h2 className="text-2xl font-semibold text-neutral-100">Wix Update</h2>
					<p className="text-sm text-neutral-400">Siga estos pasos para actualizar los datos en Wix</p>
				</div>

				<div className="space-y-6">
					<div className="space-y-3 rounded border border-neutral-700 bg-neutral-800/30 p-4">
						<div className="flex items-center gap-2">
							<span className="flex h-6 w-6 items-center justify-center rounded-full bg-sky-600 text-sm font-semibold">1</span>
							<h3 className="text-base font-medium text-neutral-100">Exportar CSV de Ciudades</h3>
						</div>
						<p className="text-sm text-neutral-400">Exportar este CSV e importarlo en el collection Ciudades en Wix</p>
						<Button2 variant="default" onClick={exportCitiesCSV} className="w-full bg-neutral-700 hover:bg-neutral-600 md:w-auto">
							Exportar Ciudades.CSV
						</Button2>
					</div>

					<div className="space-y-3 rounded border border-neutral-700 bg-neutral-800/30 p-4">
						<div className="flex items-center gap-2">
							<span className="flex h-6 w-6 items-center justify-center rounded-full bg-sky-600 text-sm font-semibold">2</span>
							<h3 className="text-base font-medium text-neutral-100">Exportar CSV de Aliados</h3>
						</div>
						<p className="text-sm text-neutral-400">Exportar este CSV e importarlo en el collection Aliados en Wix</p>
						<Button2
							variant="default"
							onClick={exportAliadosCSV}
							className="w-full bg-neutral-700 hover:bg-neutral-600 md:w-auto"
						>
							Exportar Aliados.CSV
						</Button2>
					</div>

					<div className="space-y-3 rounded border border-neutral-700 bg-neutral-800/30 p-4">
						<div className="flex items-center gap-2">
							<span className="flex h-6 w-6 items-center justify-center rounded-full bg-sky-600 text-sm font-semibold">3</span>
							<h3 className="text-base font-medium text-neutral-100">Importar CSV de Aliados desde Wix</h3>
						</div>
						<p className="text-sm text-neutral-400">Ir a Wix y exportar el CSV generado de aliados e importarlo aquí</p>
						<input
							type="file"
							accept=".csv"
							onChange={handleFileChange}
							className="w-full rounded border border-neutral-600 bg-neutral-800 px-3 py-2 text-sm text-neutral-300 file:mr-4 file:rounded file:border-0 file:bg-primary-600 file:px-4 file:py-1.5 file:text-sm file:font-medium file:text-white hover:file:bg-primary-700"
						/>
					</div>

					<div className="space-y-3 rounded border border-neutral-700 bg-neutral-800/30 p-4">
						<div className="flex items-center gap-2">
							<span className="flex h-6 w-6 items-center justify-center rounded-full bg-sky-600 text-sm font-semibold">4</span>
							<h3 className="text-base font-medium text-neutral-100">Exportar CSV de Tiendas</h3>
						</div>
						<p className="text-sm text-neutral-400">Exportar este CSV e importarlo en el collection Tiendas en Wix</p>
						<Button2
							variant="default"
							onClick={exportTiendasCSV}
							className="w-full bg-neutral-700 hover:bg-neutral-600 md:w-auto"
						>
							Exportar Tiendas.CSV
						</Button2>
					</div>
				</div>
			</div>
		</div>
	);

	const BuscarPagosDeTienda = (
		<div className="mx-auto w-full max-w-3xl space-y-6 p-4 md:p-6">
			<div className="space-y-6 rounded-lg border border-neutral-800 bg-neutral-900/50 p-6">
				<div className="space-y-0">
					<h2 className="text-2xl font-semibold text-neutral-100">Buscar pagos de tienda</h2>
					<p className="text-sm text-neutral-400">Ingrese los detalles del pago para buscarlo en el sistema</p>
				</div>

				<div className="mx-auto max-w-xl space-y-4">
					<Input
						floatingLabel="Monto"
						placeholder="0.00"
						name="reportedAmount"
						type="tel"
						value={reportedAmount}
						onChange={(value) => setReportedAmount(value)}
						containerClassName="w-full"
						allowedChars="numeric"
					/>
					<DatePicker
						floatingLabel="Fecha de Pago"
						onDateChange={setPaymentDate}
						defaultDate={paymentDate}
						containerClassName="w-full"
					/>
					<Input
						floatingLabel="Email de la tienda"
						placeholder="ejemplo@tienda.com"
						name="storeEmail"
						value={storeEmail}
						onChange={(value) => setStoreEmail(value)}
						containerClassName="w-full"
						type="email"
					/>
					<Button2
						Icon={<SearchIcon className="size-4" />}
						variant="primary"
						onClick={getStoreTransactions}
						className="!h-12 w-full"
						disabled={!reportedAmount || !paymentDate || !storeEmail}
					>
						Buscar
					</Button2>
				</div>
			</div>
		</div>
	);

	const Kpis = (
		<div className="mx-auto w-full max-w-4xl space-y-6 p-4 md:p-6">
			<div className="space-y-6 rounded-lg border border-neutral-800 bg-neutral-900/50 p-6">
				<div className="space-y-0">
					<h2 className="text-2xl font-semibold text-neutral-100">Balance de ventas</h2>
					<p className="text-sm text-neutral-400">Importar archivo CSV o Excel con el balance de ventas</p>
				</div>
				<div className="space-y-3">
					<input
						type="file"
						accept=".csv,.xls,.xlsx"
						onChange={uploadFile}
						className="w-full rounded border border-neutral-600 bg-neutral-800 px-3 py-2 text-sm text-neutral-300 file:mr-4 file:rounded file:border-0 file:bg-primary-600 file:px-4 file:py-1.5 file:text-sm file:font-medium file:text-white hover:file:bg-primary-700"
					/>
				</div>
			</div>

			{selectedCountry === 'rd' && (
				<div className="space-y-6 rounded-lg border border-neutral-800 bg-neutral-900/50 p-6">
					<div className="space-y-0">
						<h2 className="text-2xl font-semibold text-neutral-100">Transacciones bancarias</h2>
						<p className="text-sm text-neutral-400">Importar archivo CSV o Excel con las transacciones bancarias</p>
					</div>
					<div className="space-y-3">
						<input
							type="file"
							accept=".csv,.xls,.xlsx"
							onChange={uploadFile2}
							className="w-full rounded border border-neutral-600 bg-neutral-800 px-3 py-2 text-sm text-neutral-300 file:mr-4 file:rounded file:border-0 file:bg-primary-600 file:px-4 file:py-1.5 file:text-sm file:font-medium file:text-white hover:file:bg-primary-700"
						/>
					</div>
				</div>
			)}
		</div>
	);

	return (
		<>
			{internalPath.get() === '/no-access' && <NoAccess />}
			{(internalPath.get() === '/buscar-clientes' || internalPath.get() === '') && <ManageCustomers />}
			{internalPath.get() === '/manage-stores' && <ManageStores />}
			{internalPath.get() === '/comisiones-de-vendedores' && <SellerCommissionsAdmin />}
			{internalPath.get() === '/registrar-pago' && <Pay />}
			{internalPath.get() === '/registrar-pago-manual' && <RegisterPaymentManually />}
			{internalPath.get() === '/pagos-por-verificar' && <VerifyPayments />}
			{internalPath.get() === '/pagos-crypto-por-verificar' && <VerifyPayments type="crypto" />}
			{internalPath.get() === '/log-in-as' && <LogInAs />}
			{internalPath.get() === '/onboarding' && Onboarding}
			{internalPath.get() === '/kpis' && Kpis}
			{internalPath.get() === '/buscar-pagos-de-tienda' && BuscarPagosDeTienda}
			{internalPath.get() === '/simulator' && <NewSale simulator={true} key="simulator" />}
			{internalPath.get() === '/promociones' && <Promociones />}
			{internalPath.get() === '/reportes/ventas' && <Ventas />}
			{internalPath.get() === '/reportes/tiendas' && <Tiendas />}
			{internalPath.get() === '/reportes/sucursales' && <Sucursales />}
			{internalPath.get() === '/reportes/registros-de-actividad' && <RegistrosDeActividad />}
			{internalPath.get() === '/pagar-tarifa-de-recarga' && <PagarTarifaDeRecarga />}
			{internalPath.get() === '/control-de-acceso' && <AccessControl />}
			{internalPath.get() === '/configuracion-de-financiamiento' && <FinancingOptionsConfig />}
			{internalPath.get() === '/configuracion-de-promociones' && <PromotionsConfiguration />}
			{internalPath.get() === '/pagos-a-aliados' && <PagosAliados />}
			{internalPath.get() === '/notificaciones-push' && <PushNotifications />}
			{internalPath.get() === '/notificaciones-ciclo-de-vida' && <LifecycleNotifications />}
			{internalPath.get() === '/eliminacion-de-prestamos' && <LoansBatchDelete />}
			{internalPath.get() === '/campanas-publicitarias' && <MarketingCampaigns />}
			{internalPath.get() === '/comunicado-tiendas' && <StoreAnnouncementsAdmin />}
			{internalPath.get() === '/popups-tiendas' && <StorePopups />}
			{internalPath.get() === '/mdm-routing' && <MdmRouting />}
			{internalPath.get() === '/bank-account-mappings' && <BankAccountMappings />}
			{internalPath.get() === '/conciliaciones' && <Conciliaciones />}
			{internalPath.get() === '/liberar-imei' && <ReleaseImei />}
			{internalPath.get() === '/polizas-de-seguro' && <InsurancePolicies />}
			{internalPath.get() === '/store-requests' && <StoreRequests />}

			{dialogMessage && (
				<Dialog title="" onClose={() => setDialogMessage('')}>
					<div className="whitespace-pre-wrap break-words py-2 text-center text-neutral-100">{dialogMessage}</div>
				</Dialog>
			)}
		</>
	);

	function PagarTarifaDeRecarga() {
		const fee = CountrySettings?.services_config?.recargas?.one_time_activation_fee;

		const [identificationValue, setIdentificationValue] = useState('');
		const [loading, setLoading] = useState(false);
		const [notice, setNotice] = useState({ message: '', type: '' });
		const [triggerFetch, setTriggerFetch] = useState(false);
		const [searchedId, setSearchedId] = useState('');

		// Payment form state
		const [paymentBank, setPaymentBank] = useState('');
		const [paymentReference, setPaymentReference] = useState('');
		const [paymentAmount, setPaymentAmount] = useState('');
		const [paymentOriginPhone, setPaymentOriginPhone] = useState('');
		const [paymentDate, setPaymentDate] = useState('');
		const [exchangeRate, setExchangeRate] = useState(null);
		const [submittingPayment, setSubmittingPayment] = useState(false);

		const currentCountry = internalCountry.get() || userData.country;
		const banks = CountrySettings?.banks?.toSorted() || [];

		const {
			data: isNewUserData,
			loading: isNewUserLoading,
			error: isNewUserError,
			setPayload: setIsNewUserPayload,
			fetched: isNewUserFetched,
			reset: resetIsNewUserFetch
		} = useFetch('https://api.krece.app/users/isnewuser/', 'POST', triggerFetch);

		const {
			data: paymentResponse,
			// eslint-disable-next-line
			loading: paymentLoading,
			error: paymentError,
			setPayload: setPaymentPayload,
			fetched: paymentFetched,
			reset: resetPaymentFetch
		} = useFetch('https://api.krece.app/payments/processrecargafee/', 'POST', submittingPayment);

		const handleSearchSubmit = (e) => {
			e.preventDefault();
			if (!identificationValue) {
				setNotice({ message: 'Por favor ingrese el email del usuario', type: 'error' });
				return;
			}
			setNotice({ message: '', type: '' });
			setPaymentAmount(''); // Reset payment amount on new search
			resetIsNewUserFetch();
			resetPaymentFetch(); // Reset payment submission status too
			setSearchedId(identificationValue);
			setIsNewUserPayload({ user_document_id: identificationValue.trim() });
			setTriggerFetch(true);
		};

		useEffect(() => {
			if (currentCountry === 'venezuela' && !exchangeRate) {
				firestore
					.collection('DollarPrice')
					.doc('dollarPrice')
					.get()
					.then((doc) => {
						if (doc.exists) {
							setExchangeRate(doc.data()?.bcv);
						} else {
							setNotice({ message: 'No se pudo obtener la tasa de cambio BCV.', type: 'error' });
						}
					})
					.catch((err) => {
						console.error('Error fetching exchange rate:', err);
						setNotice({ message: 'Error al obtener la tasa de cambio.', type: 'error' });
					});
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [currentCountry]);

		useEffect(() => {
			setLoading(isNewUserLoading);
		}, [isNewUserLoading]);

		useEffect(() => {
			if (isNewUserFetched) {
				setTriggerFetch(false); // Reset trigger after fetch attempt

				if (isNewUserError) {
					setNotice({
						message: typeof isNewUserError === 'string' ? isNewUserError : 'Error al verificar el usuario',
						type: 'error'
					});
				} else if (isNewUserData?.is_new_user === false) {
					setNotice({ message: 'Este usuario ya pagó su tarifa de activación', type: 'info' });
				} else if (isNewUserData?.is_new_user === true && fee) {
					setPaymentAmount(currentCountry !== 'venezuela' ? fee?.toString() : (fee * exchangeRate)?.toFixed(2));
				} else if (!fee) {
					setNotice({ message: 'No se pudo obtener la tarifa de activación', type: 'error' });
				}
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [isNewUserFetched, isNewUserData, isNewUserError, searchedId, currentCountry, exchangeRate]);

		const handlePaymentSubmit = async (e) => {
			e.preventDefault();
			if (!paymentBank || !paymentReference || !paymentAmount || !paymentOriginPhone || !paymentDate) {
				setNotice({ message: 'Por favor complete todos los campos del formulario de pago.', type: 'error' });
				return;
			}
			setNotice({ message: '', type: '' });

			const payload = {
				user_document_id: searchedId.trim(),
				amount: parseFloat(paymentAmount),
				date: paymentDate, // Send selected payment date
				country: currentCountry,
				api_type: 'BNC', // As per endpoint spec, though seems specific
				reference: paymentReference,
				payment_type: 'P2C', // As per endpoint spec
				phone_num: paymentOriginPhone, // Assuming this is the phone_num for the endpoint
				bank_code: paymentBank // Assuming bank value is the code
			};

			setPaymentPayload(payload);
			setSubmittingPayment(true);
		};

		useEffect(() => {
			if (paymentFetched) {
				setSubmittingPayment(false);
				if (paymentError) {
					setNotice({ message: typeof paymentError === 'string' ? paymentError : 'Error al procesar el pago.', type: 'error' });
				} else if (paymentResponse) {
					setNotice({ message: 'Tarifa de activación pagada exitosamente.', type: 'success' });
				} else {
					setNotice({ message: paymentResponse?.status || 'Error al procesar el pago.', type: 'error' });
				}
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [paymentFetched, paymentResponse, paymentError]);

		return (
			<div className="mx-auto w-full max-w-5xl space-y-6 p-4">
				<form className="space-y-4" onSubmit={handleSearchSubmit}>
					<div className="space-y-0 xl:text-center">
						<h2 className="text-2xl font-semibold text-neutral-100">Pagar Tarifa de Recarga</h2>
						<p className="text-sm text-neutral-400">Ingrese el email del usuario para buscar la tarifa</p>
					</div>

					<div className="flex max-w-xl flex-col gap-4 pt-3 md:flex-row md:gap-2 xl:mx-auto">
						<Input
							containerClassName="w-full"
							name="cedula"
							placeholder={'Ingresar email'}
							floatingLabel={'Email'}
							value={identificationValue}
							onChange={(value) => setIdentificationValue(value)}
						/>
						<div className="ml-0 flex shrink-0 justify-end md:ml-4">
							<Button2
								Icon={<SearchIcon className="size-4" />}
								loading={loading && !submittingPayment} // Only show search loading
								variant="primary"
								className="!h-12 w-fit"
								type="submit"
								disabled={submittingPayment}
							>
								Buscar
							</Button2>
						</div>
					</div>
				</form>

				{notice.message && isNewUserData?.is_new_user !== true && (
					<Notice message={notice.message} variant={notice.type || 'error'} className="mx-auto max-w-xl" />
				)}

				{isNewUserData?.is_new_user === true && (
					<div className="mx-auto max-w-xl space-y-6 rounded-lg border border-neutral-800 bg-neutral-900/50 p-6">
						<div className="text-center">
							<p className="text-lg font-semibold text-neutral-100">
								Monto de tarifa a pagar:{' '}
								{currentCountry === 'venezuela' ? (
									<>
										<span className="text-xl text-emerald-400">${fee.toFixed(2)}</span>
										{exchangeRate && (
											<span className="text-sm text-neutral-400"> (aprox. Bs. {(fee * exchangeRate).toFixed(2)})</span>
										)}
									</>
								) : (
									<span className="text-xl text-emerald-400">
										{CountrySettings?.currency_code}
										{fee.toFixed(2)}
									</span>
								)}
							</p>
						</div>

						<form className="space-y-4" onSubmit={handlePaymentSubmit}>
							<Select
								floatingLabel="Banco de origen del Pagomovil"
								options={banks.map((bankName) => ({ label: bankName, value: bankName.split(' - ')[0] }))} // Assuming value is bank code
								defaultValue={paymentBank}
								onSelectedChange={setPaymentBank}
								placeholder="Seleccionar banco"
								containerClassName="w-full"
								disabled={submittingPayment}
							/>
							<Input
								floatingLabel="Número de referencia"
								value={paymentReference}
								onChange={setPaymentReference}
								placeholder="Ingrese el número de referencia"
								containerClassName="w-full"
								disabled={submittingPayment}
								allowedChars="numbers_only"
								validation={(value) => (value?.trim()?.length || 0) >= 6}
							/>
							<Input
								floatingLabel={`Monto del pago (en ${currentCountry === 'venezuela' ? 'bolívares' : 'moneda local'})`}
								value={paymentAmount}
								onChange={setPaymentAmount}
								placeholder="0.00"
								allowedChars="numeric"
								containerClassName="w-full"
								disabled={submittingPayment || (currentCountry === 'venezuela' && !exchangeRate)} // Disable if Vzla and no rate
							/>
							<Input
								floatingLabel="Teléfono de origen"
								value={paymentOriginPhone}
								onChange={setPaymentOriginPhone}
								placeholder="Ejemplo: 04141234567"
								allowedChars="numbers_only"
								type="tel"
								containerClassName="w-full"
								validation={(value) => (value?.trim()?.length || 0) === 11}
								disabled={submittingPayment}
							/>
							<DatePicker
								floatingLabel="Fecha del pago"
								onDateChange={setPaymentDate}
								defaultDate={paymentDate} // Keep selected date or empty
								containerClassName="w-full"
								disabled={submittingPayment}
							/>

							{notice.message && (
								<Notice message={notice.message} variant={notice.type || 'error'} className="mx-auto max-w-xl" />
							)}

							<Button2
								loading={submittingPayment}
								variant="primary"
								className="!h-12 w-full"
								type="submit"
								disabled={
									loading ||
									submittingPayment ||
									(paymentOriginPhone?.trim()?.length || 0) !== 11 ||
									(paymentReference?.trim()?.length || 0) < 6
								} // Disable if searching or submitting
							>
								Enviar Pago
							</Button2>
						</form>
					</div>
				)}
			</div>
		);
	}

	function Ventas() {
		return (
			<div className="h-full w-full p-4 md:p-6">
				<Table
					userEmail={null}
					endpoint="https://api.krece.app/tables/devices/"
					orderBy={{ columnName: 'Fecha de Compra', columnOrder: 'DESC' }}
					pagination={{ default: 100, batchSizes: [100] }}
					filter_by={[{ column_name: 'Tipo de Venta', value: 'phone' }
						// , { column_name: 'Pais', value: internalCountry.get() || userData.country }
					]}
					filters={[
						{
							column: 'Tipo de Venta',
							options: [
								{ label: 'Android', value: 'phone' },
								{ label: 'iPhone', value: 'iphone' },
								{ label: 'Recarga', value: 'recarga' }
							],
							defaultValue: 'phone'
						},
					]}
				/>
			</div>
		);
	}

	function Tiendas() {
		return (
			<div className="h-full w-full p-4 md:p-6">
				<Table
					userEmail={null}
					orderBy={null}
					endpoint="https://api.krece.app/tables/master_stores/"
					// filter_by={[{ column_name: 'Pais', value: internalCountry.get() || userData.country }]}
					// search_by={{ column: 'Email', placeholder: 'Buscar por email'}}
				/>
			</div>
		);
	}

	function Sucursales() {
		return (
			<div className="h-full w-full p-4 md:p-6">
				<Table
					userEmail={null}
					// filter_by={[{ column_name: 'Pais', value: internalCountry.get() || userData.country }]}
					orderBy={null}
					endpoint="https://api.krece.app/tables/stores/"
				/>
			</div>
		);
	}

	function RegistrosDeActividad() {
		return (
			<div className="h-full w-full p-4 md:p-6">
				<Table
					userEmail={userData?.master_store?.id}
					endpoint="https://api.krece.app/tables/actions_logs/"
					pagination={{ default: 200, batchSizes: [200] }}
					orderBy={{ columnName: 'Fecha', columnOrder: 'DESC' }}
				/>
			</div>
		);
	}

	function VerifyPayments({ type = 'bank' }) {
		const banks = CountrySettings?.banks?.toSorted() || [];
		const [tableKey, setTableKey] = useState(0);

		const [tableKey2, setTableKey2] = useState(100);
		const [rejectionReason, setRejectionReason] = useState('');

		const [selectedPayment, setSelectedPayment] = useState(null);
		const [prematch, setPrematch] = useState(null);
		const [prematchLoading, setPrematchLoading] = useState(false);
		const [prematchError, setPrematchError] = useState('');
		const [selectedMatchReference, setSelectedMatchReference] = useState('');
		const isCryptoPayment = type === 'crypto';
		const isVenezuelaPayment = selectedPayment?.country === 'venezuela';
		const isMercantilPayment = selectedPayment?.verification_bank === 'mercantil';
		const requiresFullPhone = isMercantilPayment;
		const validateOriginPhone = requiresFullPhone || (selectedPayment?.verification_bank === 'r4' && !!selectedPayment?.phone_num);
		const receiverOptions = receivingBankOptions(CountrySettings, selectedPayment?.payment_type);
		const receiverAvailable = selectedPayment?.verification_bank === 'auto' || receiverOptions.some((option) => option.value === selectedPayment?.verification_bank);
		const hasCommonPaymentFields =
			selectedPayment?.date && selectedPayment?.amount && selectedPayment?.reference && selectedPayment?.unverified_payment_id;
		const hasBankSpecificFields =
			selectedPayment?.payment_type === 'p2c'
				? validateOriginPhone
					? selectedPayment?.issuer_bank_id && validate_phone_number(selectedPayment?.phone_num || '', 'venezuela')
					: selectedPayment?.issuer_bank_id
				: selectedPayment?.payment_type === 'transfer'
					? !isMercantilPayment || selectedPayment?.issuer_bank_id
					: false;
		const shouldSuggestBankMatch = selectedCountry === 'rd' && !isCryptoPayment;
		const formValid = isCryptoPayment
			? hasCommonPaymentFields
			: isVenezuelaPayment
				? hasCommonPaymentFields && receiverAvailable && hasBankSpecificFields
				: hasCommonPaymentFields && selectedPayment?.bank_id && selectedPayment?.bank_account_number;

		const bankSelection = (bank) => {
			const bankName = bank?.trim() === 'Popular' ? 'Banco Popular' : bank?.trim();
			return {
				bank_id: bankName,
				bank_account_number: bankName === 'Banco Popular' ? '843641127' : undefined
			};
		};

		const applyMatchSuggestion = (suggestion) => {
			if (!suggestion.reference || loading) return;
			setSelectedPayment({
				...selectedPayment,
				amount: suggestion.amount,
				date: suggestion.date,
				reference: suggestion.reference,
				...bankSelection(suggestion.bank)
			});
			setSelectedMatchReference(suggestion.reference);
		};

		const updateSelectedPayment = (updates) => {
			// DatePicker emits its initial date on mount, including after applying a movement.
			if (!Object.entries(updates).some(([key, value]) => selectedPayment?.[key] !== value)) return;
			setSelectedPayment({
				...selectedPayment,
				...(selectedMatchReference ? { reference: '' } : {}),
				...updates
			});
			setSelectedMatchReference('');
		};

		const prematchEvidenceLabels = {
			exact_amount: 'Monto exacto',
			same_date: 'Misma fecha',
			near_date: 'Fecha cercana',
			reported_account: 'Cuenta reportada',
			identification_number: 'Documento',
			full_name: 'Nombre completo',
			partial_name: 'Coincidencia parcial del nombre',
			exact_reported_reference: 'Referencia exacta'
		};

		const [submitForm, setSubmitForm] = useState(false);
		const { error, loading, setPayload, reset, fetched } = useFetch(
			'https://api.krece.app/payments/processunverifiedpayment/',
			'PUT',
			submitForm
		);

		useEffect(() => {
			let cancelled = false;
			setPrematch(null);
			setPrematchError('');
			setSelectedMatchReference('');
			setPrematchLoading(false);
			if (!selectedPayment) {
				reset();
				setRejectionReason('');
				return;
			}
			if (!shouldSuggestBankMatch) return;

			const fetchPrematch = async () => {
				setPrematchLoading(true);
				const [response, requestError] = await callAPI(
					'https://api.krece.app/payments/prematchunverifiedpayment/',
					'POST',
					{ unverified_payment_id: selectedPayment.unverified_payment_id },
					userData,
					selectedCountry
				);
				if (cancelled) return;
				if (requestError) setPrematchError(requestError);
				else setPrematch(response?.prematch || null);
				setPrematchLoading(false);
			};
			fetchPrematch();
			return () => {
				cancelled = true;
			};
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [selectedPayment?.unverified_payment_id, shouldSuggestBankMatch, selectedCountry]);

		useEffect(() => {
			if (fetched && !error) {
				setSelectedPayment(null);
				setRejectionReason('');
				reset();
				setTableKey((prev) => prev + 1);
				setTableKey2((prev) => prev + 1);
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [fetched]);

		return (
			<div className="mx-auto w-full p-4 md:p-[1.25rem]">
				{selectedPayment && (
					<Dialog
						title="Información de Pago (Cliente)"
						onClose={() => setSelectedPayment(null)}
						cerrarButton={false}
						noContentWrapper
					>
						<form className="flex min-h-0 w-[520px] max-w-full flex-1 flex-col" onSubmit={(e) => e.preventDefault()}>
							<div className="min-h-0 flex-1 space-y-6 overflow-y-auto p-1 leading-normal text-neutral-200">
								<div className="flex flex-col gap-2">
								<div className="flex gap-2">
									<DatePicker
										key={selectedPayment?.date || 'payment-date'}
										className="rounded-lg bg-neutral-1000 font-semibold light:bg-neutral-900/70"
										defaultDate={selectedPayment?.date || ''}
										onDateChange={(value) => updateSelectedPayment({ date: value })}
										containerClassName="w-full"
									/>
									<Input
										inputClassName="font-semibold"
										Icon={<span className="text-neutral-500">Monto: </span>}
										value={selectedPayment?.amount?.toString() || ''}
										onChange={(value) => updateSelectedPayment({ amount: isNaN(parseFloat(value)) ? value : parseFloat(value) })}
										allowedChars="numeric"
										containerClassName="w-full"
									/>
								</div>
								<Input
									Icon={<span className="text-neutral-500">Referencia: </span>}
									value={selectedPayment?.customer_reference || ''}
									readonly={true}
									containerClassName="w-full"
								/>
								{!isCryptoPayment && (
									<Input
										Icon={<span className="text-neutral-500">Num. de cuenta: </span>}
										value={selectedPayment?.customer_bank_account_number || ''}
										readonly={true}
										containerClassName="w-full"
									/>
								)}

								{shouldSuggestBankMatch && (
									<div className="select-none space-y-3 rounded-lg border border-neutral-800 bg-neutral-900/40 p-3">
										<div className="flex items-center justify-between gap-3">
											<h3 className="text-sm font-medium text-neutral-200">Pre-match bancario</h3>
											{prematchLoading && <span className="text-xs text-neutral-400">Buscando movimientos...</span>}
										</div>

										{selectedPayment?.payment_confirmation_url && (
											<a
												href={selectedPayment.payment_confirmation_url}
												target="_blank"
												rel="noreferrer"
												className="block"
												onKeyDown={(event) => {
													if (event.key === 'Enter') event.stopPropagation();
												}}
											>
												<img
													src={selectedPayment.payment_confirmation_url}
													alt="Comprobante enviado por el cliente"
													className="max-h-52 w-full rounded-md border border-neutral-800 object-contain"
												/>
											</a>
										)}

										{prematchError && (
											<Notice message="No se pudo consultar el pre-match. Continúa con la verificación manual." variant="error" />
										)}
										{prematch?.bank_window_truncated && (
											<Notice message="La búsqueda devolvió demasiados movimientos. Verifica el pago manualmente." variant="error" />
										)}
										{prematch?.status === 'recommended' && (
											<p className="text-sm text-green-400">
												Encontré una coincidencia recomendada con confianza {prematch.confidence === 'high' ? 'alta' : 'media'}.
											</p>
										)}
										{prematch?.status === 'ambiguous' && (
											<p className="text-sm text-yellow-400">Hay varias transferencias similares. Revisa los datos antes de seleccionar.</p>
										)}
										{prematch?.status === 'no_match' && (
											<p className="text-sm text-neutral-400">No encontré una transferencia candidata.</p>
										)}
										{prematch?.status === 'invalid_payment_data' && (
											<p className="text-sm text-yellow-400">El pago no tiene monto o fecha válidos para buscar coincidencias.</p>
										)}

										<div className="space-y-2">
											{prematch?.candidates?.map((suggestion) => {
												const isRecommended = prematch.recommended_candidate_id === suggestion.id;
												const isSelected = !!selectedMatchReference && selectedMatchReference === suggestion.reference;
												const evidence = isRecommended
													? prematch.evidence.map((item) => prematchEvidenceLabels[item] || item)
													: [];
												return (
													<div
														key={suggestion.id}
														className={`rounded-md border p-3 ${isSelected ? 'border-sky-600/70 bg-sky-950/20' : 'border-neutral-800 bg-neutral-950/40'}`}
													>
														<div className="flex items-start justify-between gap-3">
															<div className="min-w-0 space-y-1">
																<div className="flex flex-wrap items-center gap-2 text-sm text-neutral-200">
																	<span className="font-semibold">RD$ {Number(suggestion.amount).toLocaleString('es-DO')}</span>
																	<span>{suggestion.date}</span>
																	{isRecommended && <span className="text-xs text-green-400">Recomendado</span>}
																</div>
																<p className="truncate text-sm text-neutral-300">{suggestion.description || 'Sin descripción'}</p>
																<p className="text-xs text-neutral-500">
																	Ref. bancaria: {suggestion.bank_reference || suggestion.serial || 'No disponible'}
																</p>
																{evidence.length > 0 && <p className="text-xs text-neutral-500">{evidence.join(' · ')}</p>}
															</div>
															<Button2
																type="button"
																variant="default"
																className="shrink-0 bg-sky-600 hover:bg-sky-800"
																disabled={loading || isSelected || !suggestion.reference}
																onKeyDown={(event) => {
																	if (event.key === 'Enter') event.stopPropagation();
																}}
																onClick={() => applyMatchSuggestion(suggestion)}
															>
																{isSelected ? 'Seleccionado' : 'Usar movimiento'}
															</Button2>
														</div>
													</div>
												);
											})}
										</div>
										{selectedMatchReference && (
											<Notice message="Movimiento seleccionado. Revisa los datos y pulsa Verificar para aplicarlo." variant="success" />
										)}
									</div>
								)}

								<h2 className="select-none text-[1.1rem] font-medium">Verificación de Pago (Krece)</h2>

								{!isCryptoPayment && isVenezuelaPayment && (
									<>
										<Select
											floatingLabel="Banco receptor"
											options={[
												{ label: 'Banco configurado', value: 'auto' },
												...receiverOptions
											]}
											defaultValue={selectedPayment?.verification_bank}
											onSelectedChange={(value) => setSelectedPayment({ ...selectedPayment, verification_bank: value })}
											placeholder="Seleccionar banco receptor"
										/>
										<Select
											floatingLabel="Tipo de pago"
											options={[
												{ label: 'Pago móvil', value: 'p2c' },
												{ label: 'Transferencia', value: 'transfer' }
											]}
											defaultValue={selectedPayment?.payment_type}
											onSelectedChange={(value) => setSelectedPayment({ ...selectedPayment, payment_type: value, verification_bank: 'auto' })}
											placeholder="Seleccionar tipo de pago"
										/>
										{selectedPayment?.payment_type === 'p2c' && (
											<>
												<Select
													floatingLabel="Banco de origen"
													options={banks.map((bank) => ({ label: bank, value: bank }))}
													defaultValue={selectedPayment?.issuer_bank_id}
													onSelectedChange={(value) => setSelectedPayment({ ...selectedPayment, issuer_bank_id: value })}
													placeholder="Seleccionar banco de origen"
												/>
												<Input
													floatingLabel={requiresFullPhone ? 'Teléfono completo de origen' : 'Teléfono de origen (opcional)'}
													placeholder="04141234567"
													value={selectedPayment?.phone_num || ''}
													onChange={(value) => setSelectedPayment({ ...selectedPayment, phone_num: value })}
													allowedChars="numbers_only"
													validation={validateOriginPhone ? (value) => validate_phone_number(value, 'venezuela') : undefined}
												/>
											</>
										)}
										{selectedPayment?.payment_type === 'transfer' && (
											<>
												<Select
													floatingLabel={isMercantilPayment ? 'Banco emisor' : 'Banco emisor (opcional)'}
													options={banks.map((bank) => ({ label: bank, value: bank }))}
													defaultValue={selectedPayment?.issuer_bank_id}
													onSelectedChange={(value) => setSelectedPayment({ ...selectedPayment, issuer_bank_id: value })}
													placeholder="Seleccionar banco emisor"
												/>
												{isMercantilPayment && (
													<Input
														floatingLabel="Cédula o RIF del emisor (opcional)"
														placeholder="V12345678"
														value={selectedPayment?.issuer_customer_id || ''}
														onChange={(value) => setSelectedPayment({ ...selectedPayment, issuer_customer_id: value })}
													/>
												)}
											</>
										)}
									</>
								)}
								{!isCryptoPayment && !isVenezuelaPayment && (
									<>
										<Select
											options={banks.map((bank) => ({ label: bank, value: bank }))}
											defaultValue={selectedPayment?.bank_id || undefined}
											onSelectedChange={(value) => updateSelectedPayment(bankSelection(value))}
											placeholder="Seleccionar banco"
										/>
										<Input
											allowedChars="numbers_only"
											placeholder="Número de cuenta"
											value={selectedPayment?.bank_account_number || ''}
											onChange={(value) => updateSelectedPayment({ bank_account_number: value })}
											validation={(value) => validate_bank_account_number(value, selectedCountry)}
										/>
									</>
								)}
								<Input
									placeholder="Referencia"
									value={selectedPayment?.reference || ''}
									onChange={(value) => updateSelectedPayment({ reference: value })}
								/>
							</div>

							{error && typeof error === 'string' && <Notice message={error || 'Ocurrió un error'} variant="error" />}

							<div className="mt-4 select-none border-t border-neutral-800 pt-4">
								<h3 className="mb-2 text-sm font-medium text-neutral-300">Razón de rechazo (opcional)</h3>
								<div className="space-y-2">
									<div
										className={`flex cursor-pointer items-center gap-2 rounded p-2 hover:bg-neutral-800/30 ${rejectionReason === 'La foto no corresponde a un comprobante de pago.' ? 'border border-blue-600/40 bg-neutral-800/40' : ''}`}
										onClick={() =>
											setRejectionReason((prev) =>
												prev === 'La foto no corresponde a un comprobante de pago.'
													? ''
													: 'La foto no corresponde a un comprobante de pago.'
											)
										}
									>
										<div
											className={`flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border ${rejectionReason === 'La foto no corresponde a un comprobante de pago.' ? 'border-blue-600' : 'border-neutral-500'}`}
										>
											{rejectionReason === 'La foto no corresponde a un comprobante de pago.' && (
												<div className="h-2 w-2 rounded-full bg-blue-600"></div>
											)}
										</div>
										<span className="text-sm text-neutral-200">La foto no corresponde a un comprobante de pago.</span>
									</div>

									<div
										className={`flex cursor-pointer items-center gap-2 rounded p-2 hover:bg-neutral-800/30 ${rejectionReason === 'Los fondos no han sido recibidos en la cuenta; verificar si el banco revirtió la transferencia.' ? 'border border-blue-600/40 bg-neutral-800/40' : ''}`}
										onClick={() =>
											setRejectionReason((prev) =>
												prev === 'Los fondos no han sido recibidos en la cuenta; verificar si el banco revirtió la transferencia.'
													? ''
													: 'Los fondos no han sido recibidos en la cuenta; verificar si el banco revirtió la transferencia.'
											)
										}
									>
										<div
											className={`flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border ${rejectionReason === 'Los fondos no han sido recibidos en la cuenta; verificar si el banco revirtió la transferencia.' ? 'border-blue-600' : 'border-neutral-500'}`}
										>
											{rejectionReason ===
												'Los fondos no han sido recibidos en la cuenta; verificar si el banco revirtió la transferencia.' && (
												<div className="h-2 w-2 rounded-full bg-blue-600"></div>
											)}
										</div>
										<span className="text-sm text-neutral-200">
											Los fondos no han sido recibidos en la cuenta; verificar si el banco revirtió la transferencia.
										</span>
									</div>

									<div
										className={`flex cursor-pointer items-center gap-2 rounded p-2 hover:bg-neutral-800/30 ${rejectionReason === 'La transferencia no fue realizada a la cuenta bancaria de Krece.' ? 'border border-blue-600/40 bg-neutral-800/40' : ''}`}
										onClick={() =>
											setRejectionReason((prev) =>
												prev === 'La transferencia no fue realizada a la cuenta bancaria de Krece.'
													? ''
													: 'La transferencia no fue realizada a la cuenta bancaria de Krece.'
											)
										}
									>
										<div
											className={`flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border ${rejectionReason === 'La transferencia no fue realizada a la cuenta bancaria de Krece.' ? 'border-blue-600' : 'border-neutral-500'}`}
										>
											{rejectionReason === 'La transferencia no fue realizada a la cuenta bancaria de Krece.' && (
												<div className="h-2 w-2 rounded-full bg-blue-600"></div>
											)}
										</div>
										<span className="text-sm text-neutral-200">
											La transferencia no fue realizada a la cuenta bancaria de Krece.
										</span>
									</div>
								</div>
							</div>
							</div>

							<div className="mt-4 flex max-w-full shrink-0 flex-col gap-2 sm:flex-row sm:justify-end">
								<Button2
									variant="default"
									className="w-full shrink-0 bg-neutral-900 hover:bg-neutral-900/70 sm:!w-auto"
									onClick={() => {
										setSelectedPayment(null);
										setRejectionReason('');
									}}
								>
									Cerrar
								</Button2>

								<Button2
									loading={loading}
									type="submit"
									variant="default"
									className={'w-full shrink-0 bg-red-600 hover:bg-red-800 sm:!w-auto'}
									onClick={() => {
										const payload = {
											unverified_payment_id: selectedPayment.unverified_payment_id,
											accept_payment: false
										};

										if (rejectionReason) {
											payload.rejection_reason = rejectionReason;
										}

										setPayload(payload);
										setSubmitForm(true);
									}}
								>
									No pude verificarlo
								</Button2>

								<Button2
									loading={loading}
									disabled={!formValid || loading}
									type="submit"
									variant="default"
									className={
										error
											? 'w-full shrink-0 bg-yellow-500/70 hover:bg-yellow-800 sm:!w-auto'
											: 'w-full shrink-0 bg-sky-600 hover:bg-sky-800 sm:!w-auto'
									}
									onClick={() => {
										const { verification_bank, ...payment } = selectedPayment;
										setPayload({ ...payment, ...manualReceiverPayload(verification_bank || 'auto') });
										setSubmitForm(true);
									}}
								>
									{error ? 'Reintentar' : 'Verificar'}
								</Button2>
							</div>
						</form>
					</Dialog>
				)}
				<div className="space-y-4">
					<div className="space-y-0">
						<h2 className="text-2xl font-semibold text-neutral-100">Verificar Pagos</h2>
						<p className="text-sm text-neutral-400">Haga click en 'Confirmar' para verificar el pago.</p>
					</div>
					<Table
						key={tableKey}
						actionButton={{
							label: 'Confirmar',
							onClick: (row) => {
								setSelectedPayment({
									unverified_payment_id: row['ID del pago'],
									amount: row['Monto'],
									date: row['fecha'],
									customer_reference: row['Referencia'],
									customer_bank_account_number: row['Numero de cuenta'],
									country: row['Pais'],
									verification_bank: row['Pais'] === 'venezuela' ? 'auto' : undefined,
									payment_type: row['Pais'] === 'venezuela' ? 'p2c' : undefined,
									payment_confirmation_url: row['Foto de confirmacion'],
									bank_id: row['Tipo de Pago']
								});
							}
						}}
						userEmail={userData?.master_store?.id}
						endpoint={isCryptoPayment ? "https://api.krece.app/tables/unverified_crypto_payments/" : "https://api.krece.app/tables/unverified_payments/"}
						recordCountLabel={isCryptoPayment ? undefined : 'solicitudes pendientes'}
						recordCountDescription={isCryptoPayment ? undefined : 'Total de solicitudes pendientes de revisión, excluyendo las cuotas ya pagadas. Se actualiza al cargar la primera página.'}
						pagination={{ default: 100, batchSizes: [100] }}
						orderBy={{ columnName: 'fecha', columnOrder: 'DESC' }}
						search_by={{ column: 'Numero de documento', placeholder: 'Número de documento', type: 'numeric' }}
						filters={isCryptoPayment ? [
							{
								column: 'Tipo de Pago',
								options: [
									{ label: 'Kontigo', value: 'kontigo' },
									{ label: 'Otros', value: 'crypto' }
								],
							}
						] : undefined}
						filter_by={isCryptoPayment ? [{ column_name: 'Tipo de Pago', value: 'kontigo' }] : undefined}
						hideExport={true}
						fillHeight
						expandable={!isCryptoPayment}
						className="h-[500px] rounded-lg border border-neutral-800 bg-neutral-900/50 p-4"
					/>
					{!isCryptoPayment && (
						<Table
							key={tableKey2}
							userEmail={userData?.master_store?.id}
							endpoint="https://api.krece.app/tables/bank_account_payments/"
							recordCountLabel="movimientos"
							pagination={{ default: 100, batchSizes: [100] }}
							orderBy={{ columnName: 'fecha', columnOrder: 'DESC' }}
							search_by={(internalCountry.get() || userData?.country) === 'venezuela' ? [
								{ column: 'Monto', placeholder: 'Monto', type: 'numeric' },
								{ column: 'Referencia Reportada', placeholder: 'Referencia reportada' }
							] : { column: 'Monto', placeholder: 'Monto', type: 'numeric' }}
							filters={
								(internalCountry.get() || userData.country) === 'rd'
									? [
											{
												column: 'Usado',
												options: [
													{ label: 'Usado Todos', value: 'all' },
													{ label: 'True', value: true },
													{ label: 'False', value: false }
												],
												defaultValue: 'all'
											}
										]
									: [
								{
									column: 'Banco',
									options: [
										{ label: 'Todos los bancos', value: 'all' },
										{ label: 'BNC', value: 'BNC' },
										{ label: 'Mercantil', value: 'Mercantil' }
									],
									defaultValue: 'all'
								}
							]
							}
							hideExport={true}
							fillHeight
							expandable
							className="h-[500px] rounded-lg border border-neutral-800 bg-neutral-900/50 p-4"
						/>
					)}
				</div>
			</div>
		);
	}
};

export default Internal;

/**
 * @typedef {Object} ClientData
 * @property {User} user
 * @property {Device[]} devices
 *
 * @typedef {Object} User
 * @property {string} centro
 * @property {boolean} welcome_message_sent
 * @property {string} photo_id_url
 * @property {string} zipcode
 * @property {string} first_name
 * @property {string} percent_down_approved
 * @property {number} max_loan_approved_3months
 * @property {string} estado
 * @property {string} direccion
 * @property {string} push_token
 * @property {string} identification_number
 * @property {number} available_loan_approved
 * @property {string} country
 * @property {EmploymentData} employment_data
 * @property {string} municipio
 * @property {string|null} store_user
 * @property {string|null} guarantor_name
 * @property {string} created_at
 * @property {string} identification_id_url
 * @property {FinancialData} financial_data
 * @property {number} interest_rate
 * @property {string} sex
 * @property {string|null} seller_store
 * @property {string[]} ontime_payments_ids
 * @property {string} registration_status
 * @property {string} phone_number
 * @property {string} level
 * @property {string} date_of_birth
 * @property {number} age
 * @property {string} user_registration_device_brand
 * @property {string|null} cne_identified
 * @property {string} parroquia
 * @property {number} available_loan_approved_krece_plus
 * @property {string} city
 * @property {string|null} marital_status
 * @property {string[]} devices_paid
 * @property {string} user_uuid
 * @property {number} max_loan_approved_6months
 * @property {number} max_loan_approved_6months_krece_plus
 * @property {string} referral_code
 * @property {string} education_level
 * @property {string} last_name
 * @property {boolean} is_test
 * @property {number} max_loan_approved_3months_krece_plus
 * @property {string} user_registration_device_model
 * @property {string[]} late_payments_ids
 * @property {boolean} is_active
 * @property {string|null} address
 * @property {string|null} client_type
 * @property {string|null} guarantor_phone_number
 * @property {string} email
 *
 * @typedef {Object} EmploymentData
 * @property {number} monthly_income_dollars
 * @property {string|null} current_position
 *
 * @typedef {Object} FinancialData
 * @property {string|null} house_owner
 * @property {string|null} simcard_payment_plan
 * @property {string|null} rent_payment
 * @property {string|null} bank_account
 * @property {number} savings
 *
 * @typedef {Object} Device
 * @property {string} operator
 * @property {string} product_description
 * @property {string} device_model
 * @property {string} sub_store
 * @property {string} created_at
 * @property {boolean} self_financed
 * @property {number} device_payments_left
 * @property {boolean} is_locked
 * @property {number} nuovopay_device_id
 * @property {string} user
 * @property {number} loan_payment_cycle
 * @property {string} country
 * @property {number} non_taxable_fees
 * @property {boolean} online_purchase
 * @property {number} total_interest
 * @property {any} date_paid_by_krece
 * @property {string} date_bought
 * @property {number} device_loan_duration
 * @property {number} payments_amount
 * @property {string} device_manufacturer
 * @property {boolean} device_paid_by_krece
 * @property {any} discount
 * @property {number} payments_amount_financed
 * @property {number} device_price
 * @property {boolean} is_test
 * @property {string} device_commercial_name
 * @property {string} anexo
 * @property {number} taxable_fees
 * @property {boolean} krece_lux
 * @property {string} seller_store
 * @property {string} device_imei_no
 * @property {string} device_type
 * @property {boolean} is_enrolled
 * @property {string} store_user
 * @property {boolean} new_chip_acquired_with_device
 * @property {string} device_management_provider
 * @property {boolean} is_released
 * @property {number} interest
 * @property {number} amount_financed
 * @property {boolean} store_financed
 * @property {string} phone_range
 * @property {number} payment_cycle_days
 * @property {number} device_confirmation_id
 * @property {string} device_serial_no
 * @property {boolean} is_active
 * @property {string} promotional_code
 * @property {string} id
 * @property {Payment[]} payments
 * @property {any[]} transactions
 *
 * @typedef {Object} Payment
 * @property {number} taxable_fees
 * @property {number} krece_fixed_fee
 * @property {boolean} paid
 * @property {number} interest
 * @property {boolean} paymentMethod
 * @property {number} amountPaid
 * @property {any} cobranza_owner
 * @property {string} country
 * @property {boolean} paid_to_store
 * @property {number} total_interest
 * @property {number} krece_percent_fee
 * @property {string} confirmationNumber
 * @property {string} created_at
 * @property {string} sub_store
 * @property {number} amount_owed_to_store
 * @property {boolean} is_active
 * @property {string} dueDate
 * @property {string} user
 * @property {boolean} screenshot
 * @property {boolean} store_financed
 * @property {number} actualAmount
 * @property {boolean} self_financed
 * @property {string} device
 * @property {number} non_taxable_fees
 * @property {string} related_store
 * @property {boolean} is_test
 * @property {boolean} checked_by_internal_team
 * @property {number} paymentPostponedTimes
 * @property {boolean} paymentPostponed
 * @property {string} id
 * @property {boolean} [second_reminder_sent]
 * @property {string} [last_reminder_date]
 * @property {number} [in_app_message_sent_count]
 */
